module.exports = __webpack_public_path__ + "img/JadeCaps_logo_F-01.28b24321.png";